import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { noProductImage } from 'src/app/models/placeholder';

@Component({
  selector: 'hotel-card-list',
  templateUrl: './hotel-card-list.component.html',
  styleUrls: ['./hotel-card-list.component.scss'],
})
export class HotelCardListComponent implements OnInit {
  @Input() hotelList: any;
  constructor(private navControl: NavController) {}

  ngOnInit() {
  }

  navigateToHotelSearch(hotel: any) {
    console.log(hotel);
    const requestObject = {
      city: hotel?.cityName,
      country: hotel?.countryName,
      entityId: hotel?.hotelCode,
      title: hotel?.hotelName,
      type: 'HOTEL',
    };
    this.navControl.navigateForward([
      '/hotel/search',
      { query: encodeURI(JSON.stringify(requestObject)) },
    ]);
  }

  handleImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = noProductImage;
  }
}
